import { visibleGallery } from "@/lib/content";
import { bookingVisible } from "@/lib/booking";
import { path } from "@/lib/routes";

export function getNavItems(content, isPreview, site) {
  const booking = bookingVisible(site, content, isPreview);
  const items = [
    { to: path("home"), key: "home", end: true },
    { to: path("kesfet"), key: "kesfet" },
    { to: path("galeri"), key: "galeri", hidden: visibleGallery(content, isPreview).length === 0 },
    { to: path("ziyaret"), key: "ziyaret" },
    { to: path("iletisim"), key: "iletisim" },
    { to: path("bilet"), key: "bilet", hidden: !booking },
  ];
  return items.filter((i) => !i.hidden);
}
